<script lang="ts">
	import { checkoutSession } from '$lib/state/checkoutSession.svelte';
	import { editable } from '$lib/storyblok/editable';
	import type { ISbStoryData } from '@storyblok/js';
	import { slide } from 'svelte/transition';

	interface Props {
		content: ISbStoryData<{}>['content'];
	}

	const { content }: Props = $props();

	let priceSubline = $derived(
		checkoutSession.selectedProduct?.component === 'product_details'
			? checkoutSession.selectedProduct.description
			: checkoutSession.selectedProduct?.component === 'cart_product_addon' &&
					checkoutSession.baseProduct?.description
	);
</script>

{#if priceSubline}
	<div use:editable={content} transition:slide>
		<p class="text-[14px]/[130%] text-brown-4">
			{priceSubline}
		</p>
	</div>
{/if}
